module.exports = __webpack_public_path__ + "img/overdue.5b4b497d.png";